import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faQuoteRight } from '@fortawesome/free-solid-svg-icons';

export const RenderTestimonial = ({ client, details }: { client: string; details: string }) => {
  return (
    <div
      className="relative mt-6 rounded-2xl shadow-2xl bg-gradient-to-br from-xencode-black via-[#1b1b1b] to-xencode-contact-black border border-xencode-gold hover:scale-[1.02] transition-transform duration-300"
      data-aos="fade-up"
    >
      {/* Decorative quote icons */}
      <FontAwesomeIcon
        icon={faQuoteLeft}
        className="absolute top-4 left-4 text-xencode-gold text-xl opacity-30"
      />
      <FontAwesomeIcon
        icon={faQuoteRight}
        className="absolute bottom-4 right-4 text-xencode-gold text-xl opacity-30"
      />

      {/* Testimonial content */}
      <div className="px-8 py-10 text-white text-center relative z-10">
        <p className="text-sm md:text-base italic leading-relaxed mb-6 tracking-wide">{details}</p>
        <div className="mt-4 text-xencode-gold text-sm font-bold tracking-widest">
          — {client.toUpperCase()} —
        </div>
      </div>
    </div>
  );
};
